// extracted by css-extract-rspack-plugin
export default {"hiddenAvatar":"ReviewSummaryItem-module__hiddenAvatar__hAzvn"};